module.exports = __webpack_public_path__ + "static/media/CTLI_16-444w.44c90b1d.jpg";